import styled from 'styled-components';
import DropdownArrow from '@Shared/DropdownArrow';
import DropDown from '@Shared/DropdownContent';
import Button from '@Shared/MenuButton';

export const StyledDropDown = styled(DropDown).attrs({
  role: 'menu'
})`
  right: 16px;
  top: 55px;
  border-radius: 3px;
  width: 185px;
  ${props => props.isDropdownExpanded && 'display: block;'};
`;

export const MenuButton = styled(Button)`
  color: ${props => props.theme.carvana.white.primary};
  font-size: 11px;
  white-space: nowrap;
`;

export const StyledButton = styled(Button)`
  font-size: 12px;
  height: 39px;
  justify-content: flex-start;
  padding: 0px 18px;
  letter-spacing: 0;
`;

export const StyledArrowDropDown = styled(DropdownArrow)`
  fill: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary)};
  width: 20px;
`;

export const MenuTitle = styled.span`
  color: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary)};
`;

export const MenuWrapper = styled.div`
  display: inline-flex;
  padding: 5px 20px 5px 2px;
  position: relative;
  ${props => props.isDropdownExpanded && 'z-index: 101;'};
`;

export const OutsideClickWrapper = styled.div`
  display: none;
  ${props => props.isDropdownExpanded && 'display: block;'};
  background: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
`;
